import React from 'react';
import { Navbar, Nav } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Logo from '../Image/logo.png';
import { useNavigate } from 'react-router-dom';
import { suprimerClient } from '../Redux/actions/actionClient';
import { suprimerReservation } from "../Redux/actions/actionReservation";
import { suprimerOffre } from "../Redux/actions/actionOffre";
import { useSelector, useDispatch } from 'react-redux';
import '../Css/nav.css';

const NavBar = () => {

  let navigate = useNavigate();
  let dispatch = useDispatch();
  const client = useSelector((state) => state.client);

  const handleLogout = () => {
    localStorage.removeItem('client');
    localStorage.removeItem('tokenClient');
    dispatch(suprimerReservation());
    dispatch(suprimerOffre());
    localStorage.removeItem('reservation');
    localStorage.removeItem('offre');
    navigate('/');
    dispatch(suprimerClient());

  }

  return (
    <Navbar fixed="top" expand="lg">
      <Navbar.Brand as={Link} to="/" title="accueil"><img src={Logo} width="80px" alt="logo e-kaly" /></Navbar.Brand>
      <Navbar.Toggle aria-controls="navbarScroll" />
      <Navbar.Collapse id="navbarScroll">
        <Nav
          className="mx-auto my-lg-0"
          style={{ maxHeight: '200px' }}
          navbarScroll
        >
          <Nav.Link to="/marche" as={Link} title="comment ça marche" className={client.length === 0 ? "comment" : ""}><i className=''></i>Comment ça marche</Nav.Link>
          <Nav.Link to="/restaurant" as={Link} title="restaurant" ><i className=''></i><i className='fa fa-home'></i>Restaurants</Nav.Link>
          {client.length === 0 ? <Nav.Link to="/inscriptionClient" as={Link} title="inscription client"><i className='fa fa-users'></i>S'inscrire</Nav.Link> : ''}
          {client.length === 0 ? <Nav.Link to="/loginClient" as={Link} title="login client"><i className='fa fa-sign-in'></i>Se connecter</Nav.Link> : ''}
          <Nav.Link to="/contact" as={Link} title="contact"><i className='fa fa-phone'></i>Contact</Nav.Link>
        </Nav>
        {client.length === 0 ? <Nav.Link to="/loginRestaurant" as={Link} className="restaurant" title="login restaurant"><span> <i className='fa fa-cutlery'></i> Accès Restaurateur</span></Nav.Link> : ''}
        {client.length !== 0 ? <Nav.Link to="/client/donner" as={Link} className="clientNav" title="Compte client"><span> <i className='fa fa-user'></i> {client.nom} {client.prenom}</span></Nav.Link> : ''}
        {client.length !== 0 ? <Nav.Link to="/" as={Link} className="clientDeconnexion" onClick={handleLogout} title="Deconnexion"><span> <i className='fa fa-power-off'></i> Se deconnecter</span></Nav.Link> : ''}
      </Navbar.Collapse>
    </Navbar>
  )
}

export default NavBar